import { CorporatePartnershipImage, OrderanOfficeLibraryImage } from 'assets';
import React, { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import Card, { ICard } from '@/components/Partnership/Common/Card';
import Layout from '@/components/Partnership/Common/Card/Layout';
import Header from '@/components/Partnership/Common/Header';
interface Props {
  className?: string;
}
const ForCorporatesSection: FC<Props> = ({ className }) => {
  const list: ICard[] = [
    {
      id: 1,
      title: 'Order an Office Library',
      button: {
        link: 'https://go.zebralearn.com/inquiry-form',
        text: 'Contact Us →',
      },
      image: OrderanOfficeLibraryImage,
      pointers: [
        'Increase visibility across ZebraLearn’s learner ecosystem',
        'Data-driven promotion for higher reach and engagement',
      ],
      tags: ['LINKEDIN', 'META', 'OTHERS'],
    },
    {
      id: 2,
      title: 'Corporate Partnership',
      button: {
        link: 'https://go.zebralearn.com/inquiry-form',
        text: 'Contact Us →',
      },
      image: CorporatePartnershipImage,
      pointers: [
        'Long-term learning collaboration',
        'Custom content & bulk solutions',
      ],
      tags: ['LINKEDIN', 'META', 'OTHERS'],
    },
  ];
  return (
    <div className={twMerge('', className)}>
      <Header title='For Corporates' className='md:pb-4 mb-[18px]' />
      <Layout>
        {list.map((i) => (
          <Card key={i.id} card={i} />
        ))}
      </Layout>
    </div>
  );
};

export default ForCorporatesSection;
